(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["byane-category-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.byane-category-menu[open]').forEach((menu) => {
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
      menu.open = false;
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.byane-category-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 1024px)').matches) return;
    const menu = event.target.closest('.byane-category-menu');
    if (menu) menu.open = true;
  });
  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 1024px)').matches) return;
    const menu = event.target.closest('.byane-category-menu');
    if (menu && !menu.contains(event.relatedTarget) && !menu.contains(document.activeElement)) menu.open = false;
  });
  } catch(e) { console.error(e); }
})();

})();
